import React from "react";
import './homeheader.css'
import CircleIcon from "../../assets/CircleIcon";
import SparkleIcon from "../../assets/SparkleIcon";

export function HomeHeaderComponent() {
    return (<div className="homeHeader">
        <div className="shimmer"/>
        <CircleIcon className="homeHeaderCircle one"/>
        <CircleIcon className="homeHeaderCircle two"/>
        <CircleIcon className="homeHeaderCircle three"/>
        <CircleIcon className="homeHeaderCircle five"/>
        <CircleIcon className="homeHeaderCircle six"/>
        <CircleIcon className="homeHeaderCircle seven"/>
        <CircleIcon className="homeHeaderCircle eight"/>
        <SparkleIcon className="homeHeaderSparkle one"/>
        <SparkleIcon className="homeHeaderSparkle two"/>
        <SparkleIcon className="homeHeaderSparkle three"/>
        <div className="fade"/>
        <div className="headerTextWrapper">
            <div className="headerH1TextWrapper">
                <CircleIcon className="homeHeaderCircle four"/>
                <h1 className="homeHeaderText">ShesAMobileDev</h1>
            </div>
            <h3 className="homeHeaderText">Rewrite your career, one line of code at a time</h3>
        </div>
    </div>);
}
